import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { SystemVersionRest } from '../system-versions.rest';
import { SystemVersion } from '../system-version.model';
import { SystemVersionHeader } from '../system-versions-header.model';
import { SystemVersionComponent } from '../system-version/system-version.component';
import { SystemVersionElementsComponent } from '../system-version-elements/system-version-elements.component';
import { TranslatorService } from '../../../core/translator/translator.service';
import { DictionaryRest } from '../../../dictionaries/dictionary/dictionary.rest';
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';

@Component({
  selector: 'smp-systemversions',
  templateUrl: './system-versions.component.html',
  styleUrls: ['./system-versions.component.scss']
})

export class SystemVersionsComponent implements OnInit, HasPermissions {
  permissions: Permissions;

  private systemVersions: SystemVersion[];
  private systemVersionHeader: SystemVersionHeader[] ;
  public isAddEnable: boolean = true;
  private isEditable: boolean;
  private dictionaries: any[];

  @ViewChildren(SystemVersionElementsComponent) elements: QueryList<SystemVersionElementsComponent>;
  @ViewChild(SystemVersionComponent) public systemVersionModal: SystemVersionComponent;

  constructor(private translateService: TranslatorService,
    private rest: SystemVersionRest,
    private dictionaryRest: DictionaryRest,
    private spinnerService: SpinnerService,
    private permissionService: PermissionsService) { }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  ngOnInit() {
    this.spinnerService.show();
    this.setPermissions('SystemVersion');
    this.isAddEnable = this.permissions.canAdd;
    this.isEditable = this.permissions.canEdit;
    this.getDisctionaries();
  }

  onSuccessOperation(value){
    this.refreshData(value.value, value.isAdded);
  }


  onRowEdit(event){
    this.systemVersionModal.openForEdit(event.value, this.dictionaries);
  }

  onRowAdd(){
    let header = new SystemVersionHeader();
    header.id = 1;
    this.systemVersionModal.openForAdding(header, this.dictionaries);
  }

  private refreshData(row: SystemVersion, isAdded: boolean) {
    if (isAdded) {
      let header = this.systemVersionHeader.find(x => x.id === row.universalDictionaryId);
      header.elements.push(row);
      let component = this.elements.find(e => e.data.id === row.universalDictionaryId);
      component.grid.refreshData();
      component.panel.expanded = true;
      component.grid.selectedItemId = row.id;
    }
  }

  private GrpoupedObject() {
    this.systemVersionHeader = new Array<SystemVersionHeader>();
    this.dictionaries.forEach(d => {
      let header = new SystemVersionHeader();
      header.definitionName = d.value;
      header.id = d.id;
      header.elements = this.systemVersions.filter(s => s.universalDictionaryId === d.id);
      this.systemVersionHeader.push(header);
    });
  }

  private getDisctionaries(){
    this.dictionaryRest.getDictionaries(1).subscribe((dictionaries: any[]) => {
      this.dictionaries = dictionaries;
      if(dictionaries.length > 0){
        this.rest.getSystemVersions.call(this.rest).subscribe((systemVersionsInfo: SystemVersion[]) => {
          this.systemVersions = systemVersionsInfo;
          this.GrpoupedObject();
          this.spinnerService.hide();
        });
      }
    });
  }
}
